<template>
	<div class="sidebar">
		<div class="sidebar-header">
			<img src="../assets/image.png" alt="">
			<h2 class="logo">效果投放系统</h2>
		</div>
		<el-menu :default-active="activeMenu" class="sidebar-menu" :collapse="isCollapse" :collapse-transition="false"
			@select="handleMenuSelect">
			<el-menu-item index="/index">
				<i class="el-icon-document"></i>
				<span slot="title">订单管理</span>
			</el-menu-item>
			<el-menu-item index="/dashboard">
				<i class="el-icon-data-analysis"></i>
				<span slot="title">集运数据</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { ElMenu, ElMenuItem } from 'element-plus';

export default defineComponent({
	name: 'Sidebar',
	components: {
		ElMenu,
		ElMenuItem
	},
	data() {
		return {
			isCollapse: false
		}
	},
	computed: {
		activeMenu() {
			const currentPath = this.$route.path;
			const meta = this.$route.meta;
			if (meta.parentRoute) {
				return meta.parentRoute;
			}
			return currentPath;
		}
	},
	methods: {
		handleMenuSelect(index) {
			if (this.$route.path === index) {
				return;
			}
			this.$router.push(index);
		}
	}
});
</script>

<style lang="scss" scoped>
.sidebar {
	width: 240px;
	height: 100vh;
	background-color: #304156;
	display: flex;
	flex-direction: column;
	flex-shrink: 0;

	.sidebar-header {
		height: 80px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #2b3a4a;
		border-bottom: 1px solid #1f2d3d;
		padding: 12px 16px;
		gap: 8px;

		img {
			width: 36px;
			height: 36px;
			object-fit: contain;
		}

		.logo {
			color: #fff;
			font-size: 14px;
			font-weight: 600;
			margin: 0;
			white-space: nowrap;
		}
	}

	.sidebar-menu {
		flex: 1;
		border-right: none;
		background-color: #304156;

		:deep(.el-menu-item) {
			color: #bfcbd9;
			transition: all 0.3s;
			border-radius: 8px;
			padding-left: 0px !important;
			margin: 4px 8px;

			&:hover {
				background-color: #263445;
				color: #409eff;
			}

			&.is-active {
				background-color: #409eff;
				color: #fff;
			}
		}

		:deep(.el-icon) {
			margin-right: 8px;
		}
	}
}
</style>
